import theme from '../../../styles/theme.mjs';
import styled, { css } from 'styled-components';

const thumbColor = theme.colors.white;
const rangeColor = `${theme.colors.white}4D`;
const disabledColor = `${theme.colors.darkGray}`;
const activeThumbShadeColor = `${theme.colors.white}4D`;
const thumbCss = css `
  height: 11px;
  width: 11px;
  background-color: ${({ disabled }) => (disabled ? disabledColor : thumbColor)};
  border-radius: 50%;
  border: none;
  transition: ${theme.animation.duration.quick2} ${theme.animation.easing.productive.standard};
`;
const hoveredThumbCss = css `
  box-shadow: 0 0 0 8px ${({ disabled }) => (disabled ? `transparent` : activeThumbShadeColor)};
`;
const StyledRangeInput = styled.input `
  margin: 4px 0;
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  cursor: pointer;
  outline: none;
  border-radius: 1px;
  height: 3px;
  background: ${({ progress, disabled }) => `linear-gradient(to right, ${disabled ? disabledColor : thumbColor} ${progress}%, ${disabled ? disabledColor : rangeColor} ${progress}%)`};

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    ${thumbCss}
  }

  &::-moz-range-thumb {
    ${thumbCss}
  }

  @media (pointer: fine) {
    &::-webkit-slider-thumb:hover {
      ${hoveredThumbCss}
    }
    &::-moz-range-thumb:hover {
      ${hoveredThumbCss}
    }
  }
`;

export { StyledRangeInput, activeThumbShadeColor, disabledColor, rangeColor, thumbColor, thumbCss };
//# sourceMappingURL=RangeSlider.styles.mjs.map
